import dashboardItemList from 'layouts/sidebar/dashboardItemList';
import { useRecoilValue } from 'recoil';
import { userInfoState } from 'recoil/user/atom';
import { ROLE_TYPE } from 'types/enumType';

import { decryptString } from '../../util/encryptUtil';
import HeaderNavItem from './HeaderNavItem';

function HeaderNavList() {
  const { role: encryptRole } = useRecoilValue(userInfoState);
  const role = decryptString(encryptRole);

  return (
    <ul className={'gnb'}>
      {dashboardItemList.map((item) => {
        if (item.path === 'admin' && role !== ROLE_TYPE.ADMIN) {
          return null;
        }
        if (item.path === 'home/status-board') {
          return null;
        }

        return item.isShow && <HeaderNavItem item={item} key={item.href} />;
      })}
    </ul>
  );
}

export default HeaderNavList;
